/* eslint-disable no-console */
console.log( 'Hello World! (from create-block-navigationgermanhelp block)' );
/* eslint-enable no-console */
